export default "__VITE_ASSET__BM_tq6Nj__"